// extracted by mini-css-extract-plugin
module.exports = {"hiddenBeforeAnimation":"AnimatedComponent_hiddenBeforeAnimation__GZKxc","afterAnimation":"AnimatedComponent_afterAnimation__ycKhu"};